import React, { useMemo } from "../../../__compat__/react/main.entry.mjs.mjs";
import { useLocale } from "../../LocaleProvider/index.mjs.mjs";
import { isRange } from "../dateHelpers.mjs.mjs";
import { StyledDateSummaryContainer, StyledDateSummaryLayout, StyledDateSummaryDay, StyledDateSummaryMonth, StyledDateSummaryYear, } from "./DateSummary.styles.mjs.mjs";
function pickDateParts(parts) {
    return parts
        .filter((item) => ['month', 'year', 'day'].includes(item.type))
        .reduce((acc, item) => {
        acc[item.type] = item.value;
        return acc;
    }, {});
}
export const DateSummary = ({ value }) => {
    const { localeIdentifier, datePicker: locale } = useLocale();
    const monthFormat = isRange(value) ? 'short' : 'long';
    const formatter = useMemo(() => Intl.DateTimeFormat(locale.dateLocale || localeIdentifier, {
        month: monthFormat,
        day: 'numeric',
        year: 'numeric',
    }), [locale.dateLocale, localeIdentifier, monthFormat]);
    const input = isRange(value) ? [...value] : [value];
    const [partsStart, partsEnd] = input.map((date) => {
        return date ? pickDateParts(formatter.formatToParts(date)) : date;
    });
    return (React.createElement(StyledDateSummaryContainer, { role: "presentation" }, isRange(value) ? (React.createElement(React.Fragment, null,
        partsStart !== null && (React.createElement("span", null,
            React.createElement(StyledDateSummaryDay, null, partsStart.day),
            React.createElement(StyledDateSummaryMonth, null, partsStart.month))),
        partsEnd !== null && (React.createElement(React.Fragment, null,
            React.createElement("span", null, "to"),
            React.createElement("span", null,
                React.createElement(StyledDateSummaryDay, null, partsEnd.day),
                React.createElement(StyledDateSummaryMonth, null, partsEnd.month)))))) : (React.createElement(StyledDateSummaryLayout, null,
        React.createElement(StyledDateSummaryDay, null, partsStart === null || partsStart === void 0 ? void 0 : partsStart.day),
        React.createElement(StyledDateSummaryMonth, null, partsStart === null || partsStart === void 0 ? void 0 : partsStart.month),
        React.createElement(StyledDateSummaryYear, null, partsStart === null || partsStart === void 0 ? void 0 : partsStart.year)))));
};
//# sourceMappingURL=DateSummary.mjs.mjs.map